import { resolveEstadoGestionIngreso } from "../../../utils/estadosGestionIngreso";

interface IPillEstadoGestionIngresoProps {
  /** Nombre del BusPerEstado: CITADO, ASISTE o INGRESO_EFECTIVO. */
  estado?: string | null;
}

/**
 * Pill de la columna "Estado" de Gestión de Ingreso. Mismo formato que el pill
 * de "Validación" (PillValidacionCedula) para que ambas columnas se lean igual.
 */
const PillEstadoGestionIngreso = ({ estado }: IPillEstadoGestionIngresoProps) => {
  const cfg = resolveEstadoGestionIngreso(estado);
  return (
    // textTransform none: las tablas de Selección ponen sus celdas en mayúsculas.
    <span style={{ display: "inline-flex", alignItems: "center", gap: "5px", padding: "4px 10px", borderRadius: "14px", background: cfg.bg, color: cfg.color, fontSize: "11.5px", fontWeight: 600, fontFamily: "Roboto, sans-serif", whiteSpace: "nowrap", border: `1px solid ${cfg.color}22`, textTransform: "none", lineHeight: "normal" }}>
      <span className="material-symbols-outlined" style={{ fontSize: "15px", lineHeight: 1 }}>{cfg.icon}</span>
      {cfg.label}
    </span>
  );
};

export default PillEstadoGestionIngreso;
